import { get } from 'lodash';

import { AppState, OrderItem } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'cancelOrderModalState');

export const getOpen = (state: AppState) => get(root(state), 'open', false);
export const getOrderItems = (state: AppState): OrderItem[] => get(root(state), 'orderItems', []);
